import { render, staticRenderFns } from "./ContactGrideComponent.vue?vue&type=template&id=c52b5b04&scoped=true&"
import script from "./ContactGrideComponent.vue?vue&type=script&lang=js&"
export * from "./ContactGrideComponent.vue?vue&type=script&lang=js&"
import style0 from "./ContactGrideComponent.vue?vue&type=style&index=0&id=c52b5b04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52b5b04",
  null
  
)

export default component.exports